import type { XmlImportNodeItem, XmlImportSectionItem } from '@/utils/xml'
import { mapNodeTree } from '@/utils/xml'

export const resolveSectionIds = (
  sections: XmlImportSectionItem[],
  tagIdMap: Map<string, string>,
  colorIdMap: Map<string, string>
): XmlImportSectionItem[] =>
  sections.map((section) => ({
    ...section,
    nodes: mapNodeTree(section.nodes, (node: XmlImportNodeItem, children) => {
      const colorId = node.colorId ? colorIdMap.get(node.colorId) : null

      return {
        ...node,
        tagIds: node.tagIds.map((tagId) => tagIdMap.get(tagId) || tagId),
        ...(colorId ? { colorId } : {}),
        blocks: node.blocks.map((block) => {
          const blockColorId = block.colorId
            ? colorIdMap.get(block.colorId)
            : null

          return {
            ...block,
            ...(blockColorId ? { colorId: blockColorId } : {}),
          }
        }),
        children,
      }
    }),
  }))
